import { useMemo } from 'react';

export type SearchTooltipConfig = {
  enabled?: boolean;
  title?: string;
  body?: string;
  placeholders?: Array<string>;
  dismissDelay?: number;
};

export const useSearchTooltipConfig = (config?: SearchTooltipConfig) => {
  const tooltipTitle = config?.title?.trim() || '';
  const tooltipBody = config?.body?.trim() || '';
  const enabled = !!config?.enabled;
  const shouldShowTooltip = enabled && !!tooltipTitle;

  const normalizedPlaceholders = useMemo(
    () => (config?.placeholders || []).map((p: string) => (typeof p === 'string' ? p.trim() : '')).filter(Boolean),
    [config?.placeholders]
  );

  const dismissDelay = config?.dismissDelay ?? 5000;

  return {
    enabled,
    shouldShowTooltip,
    tooltipTitle,
    tooltipBody,
    normalizedPlaceholders,
    dismissDelay,
  };
};
